$(function(){
	var COOKIE_NAME = '_ct_site_banner_is_open';
	function setCookie(name, value, days) {
		var expires = "";
		var date = new Date();
		date.setTime(date.getTime() + (days*24*60*60*1000));
		expires = "; expires=" + date.toUTCString();
		document.cookie = name + "=" + (value || "")  + expires + "; path=/";
	}
	function getCookie(name) {
		var nameEQ = name + "=";
		var ca = document.cookie.split(';');
		for(var i=0;i < ca.length;i++) {
			var c = ca[i];
			while (c.charAt(0)==' ') c = c.substring(1,c.length);
			if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
		}
		return null;
	}
	function showHideBanner() {
		if (getCookie(COOKIE_NAME) == '0') {
			$('.site-banner').hide();
		} else {
			$('.site-banner').show();
		}
	}
	$('.close-banner').on('click', function() {
		$('.site-banner').hide();
		setCookie(COOKIE_NAME, '0', 1);
	});
	showHideBanner();
});